import { HttpClient } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { CommonModule, DatePipe, Location } from '@angular/common';
import { AddService } from 'src/app/shared/services/userservices/add.service';
import { NgForm } from '@angular/forms';
import { FormsModule } from '@angular/forms';
import { DashboardService } from 'src/app/shared/services/dashboardservices/dashboard.service';
import { SharedModeService } from 'src/app/shared/services/shared-mode.service';
import { SettingservicesService } from 'src/app/shared/services/settingservices/settingservices.service';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { LoaderComponent } from 'src/app/shared/components/loader/loader.component';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-user-attendance-list',
  templateUrl: './user-attendance-list.component.html',
  styleUrls: ['./user-attendance-list.component.css'],
  standalone: true,
  imports: [CommonModule, FormsModule, LoaderComponent, RouterModule, MatPaginatorModule],
  providers: [DatePipe],
  animations: [
    trigger('slideDown', [
      state('collapsed', style({
        height: '0',
        opacity: '0',
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: '1',
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('300ms ease-in-out')
      ])
    ])
  ]
})

export class UserAttendanceListComponent implements OnInit {
  isEditing = false;
  isSelected: any;
  user: any;
  showSpinner: any;
  attendances: any;
  nameFilter: any;
  dateFilter: any;
  selectedType: any;
  attendanceRequest: any[] = [];
  noRequest: any;
  check_in: any;
  check_out: any;
  overtime: any;
  reason: any;
  reasonModal = '';
  status: any;
  type: any;
  id: any;
  attendence_id: any;
  data: any;
  userAttendance: any;
  id1: any;
  attendence_id1: any;
  check_in1: any;
  check_out1: any;
  overtime1: any;
  reason1 = '';
  status1: any;
  type1: any;
  startDateFilter: any;
  endDateFilter: any;
  working_hours: any;
  selectedIds = '';
  selectedMode: any;
  datamode: any;
  userInfo: any;
  colormode: any;
  formattedStartDate: any;
  formattedEndDate: any;
  sdate: any;
  edate: any;
  filtername: any;
  filtertype: any;
  filterstatus: any;
  filtermonth: any;
  approve: any;
  acceptanceData: any[] = [];
  admin_id1: any;
  admin_reason1: any;
  Admin_detail: any = { admin: {} };

  pagedAttendanceData: any[] = []; // To hold data for the current page
  pageSize = 25; // Comment: Set the default page size
  currentPage = 0; // Comment: Set the default current page
  @ViewChild(MatPaginator) paginator!: MatPaginator; // Comment: ViewChild to access the paginator
  isFilterExpanded = false; // For expandable/collapsible filter section

  constructor(
    public router: Router,
    private http: HttpClient,
    public _location: Location,
    private addService: AddService,
    private datePipe: DatePipe,
    public dashboardService: DashboardService,
    private settings: SettingservicesService,
    private sharedmode: SharedModeService,
  ) {
    this.user = JSON.parse(localStorage.getItem('user') || '');
    const user_role = JSON.parse(this.user.user_role.user_roles);
    this.user_detail();

    if (user_role.role_type == "Employee") {
      this.router.navigate(['/dashboard-1']);
    }
  }

  ngOnInit(): void {
    this.getAtendancerequest()
    this.sharedmode.data$.subscribe(mode => {
      this.selectedMode = mode;
    });
    this.getTextForAutomation();
  }
  detailAdmin(data: any) {
    this.Admin_detail = data

  }
  RejectionData: any[] = [];
  gettextauto: any;
  getTextForAutomation() {
    this.showSpinner = true;
    this.settings.getTextAuto().then((value) => {
      this.gettextauto = value?.data;
      this.RejectionData = this.gettextauto.filter((item: any) => item.title.trim() === "ATTENDANCE_REJECTION_TEXT");
      this.acceptanceData = this.gettextauto.filter((item: any) => item.title.trim() === "ATTENDANCE_ACCEPTENCE_TEXT");
      this.showSpinner = false;
    })
  }

  rejectedReason = '';
  setReason(text: string) {
    this.rejectedReason = text;
    this.reason1 = this.rejectedReason;
    this.reasonModal = this.rejectedReason;
  }


  toggleMode(mode: string) {
    this.datamode
    this.sharedmode.setMode(mode);
  }

  goToReports() {
    this.router.navigate(['/attendance-reports']);
  }

  editMode() {
    this.isEditing = true;
  }

  cancelEdit() {
    this.attendanceRequest.forEach(data => {
      if (data.status === 'pending') {
        data.isSelected = false;
      }
    });
    this.isEditing = false;
  }

  // Toggle filter section expand/collapse
  toggleFilterSection() {
    this.isFilterExpanded = !this.isFilterExpanded;
  }

  // Get initials from name for avatar
  getInitials(name: string): string {
    if (!name) return '';
    return name
      .split(' ')
      .map(n => n[0])
      .join('')
      .substring(0, 2)
      .toUpperCase();
  }

  getOrdinal(n: number): string {
    if (n === 1) return '1st';
    if (n === 2) return '2nd';
    if (n === 3) return '3rd';
    return n + 'th';
  }

  getRequestNumberLabel(monthlySequence: number | null | undefined): string {
    if (monthlySequence === null || monthlySequence === undefined) {
      return '';
    }

    const sequence = Number(monthlySequence);
    if (!Number.isFinite(sequence) || sequence <= 0) {
      return '';
    }

    return `${this.getOrdinal(sequence)} Request`;
  }

  // Handle page change event
  onPageChange(event: PageEvent) {
    this.pageSize = event.pageSize;
    this.currentPage = event.pageIndex;
    this.updatePagedData();
  }

  // Update the paged data based on the current page and page size
  updatePagedData() {
    const startIndex = this.currentPage * this.pageSize;
    const endIndex = startIndex + this.pageSize;
    this.pagedAttendanceData = this.attendanceRequest.slice(startIndex, endIndex);
  }

  getAtendancerequest() {
    this.showSpinner = true;

    this.addService.getrequest().then((value) => {
      debugger
      this.attendanceRequest = value.data;
      this.attendanceRequest.sort((a, b) => {
        if (a.status === 'pending' && b.status !== 'pending') {
          return -1;
        } else if (a.status !== 'pending' && b.status === 'pending') {
          return 1;
        } else {
          return 0;
        }
      });
      this.updatePagedData(); // Update the paged data initially
      this.showSpinner = false;
    });

  }

  countPending(): number {
    return this.attendanceRequest.filter(data => data.status === 'pending' && data.isSelected).length;
  }
  // selectAllPending() {
  //   this.attendanceRequest.forEach(data => {
  //     if (data.status === 'pending') {
  //       data.isSelected = true;

  //     }
  //   });


  // }


  navigateToDetails(id: number) {
    this.router.navigate(['../attendance-management', id]);
  }

  select(attendanceId: number) {

    const isSelected = this.selectedIds.includes(attendanceId.toString());

    if (!isSelected) {
      if (this.selectedIds.length > 0) {
        this.selectedIds += ',';
      }
      this.selectedIds += attendanceId.toString();
    } else {
      this.selectedIds = this.selectedIds
        .split(',')
        .filter((id: string) => id !== attendanceId.toString())
        .join(',');
    }
  }

  slectedreq(approve: NgForm) {
    this.showSpinner = true;
    const ids = this.selectedIds;
    const rea = approve.value.reason;
    const adminid = this.userInfo.id;
    this.addService.selectedaprove(ids, rea, adminid).then((value) => {
      this.showSpinner = false;
    })
  }

  slectedrejectreq(approve: NgForm) {
    this.showSpinner = true;
    const ids = this.selectedIds;
    const rea = approve.value.reason;
    const adminid = this.userInfo.id;
    this.addService.selectedreject(ids, rea, adminid).then((value) => {
      this.showSpinner = false;
    })
  }
  // isReasonValid(): boolean {
  //   return this.reasonModal.trim().length < 50;
  // }


  rejectAll(approve: NgForm) {

    this.showSpinner = true;
    this.filtername;
    this.formattedStartDate;
    this.formattedEndDate;
    this.filtertype;
    this.filterstatus;
    this.filtermonth;

    const rea = approve.value.reason;
    const adminid = this.userInfo.id;
    this.addService.allReject(adminid, rea,
      this.filtername,
      this.formattedStartDate,
      this.formattedEndDate,
      this.filtertype,
      this.filterstatus,
      this.filtermonth,
    ).then((value) => {
      this.showSpinner = false;
    })
  }


  anyCheckboxSelected(): boolean {
    return this.attendanceRequest.some(data => data.isSelected);
  }

  onSubmit(f: NgForm) {

    this.showSpinner = true;
    this.filtername = f.value.name;
    this.filtertype = f.value.type;
    this.filterstatus = f.value.status;
    const startDateFilter = f.value.start_date
    const endDateFilter = f.value.end_date
    this.filtermonth = f.value.monthtype
    if (startDateFilter === null || startDateFilter === undefined) {
      this.startDateFilter = this.endDateFilter;
    }
    if (endDateFilter === null || endDateFilter === undefined) {
      this.endDateFilter = this.startDateFilter;
    }

    // Parsing Date objects
    this.sdate = startDateFilter ? new Date(startDateFilter) : null;
    this.edate = endDateFilter ? new Date(endDateFilter) : null;

    // Format date
    this.formattedStartDate = this.sdate ? this.formatDate(this.sdate) : '';
    this.formattedEndDate = this.edate ? this.formatDate(this.edate) : '';
    this.addService.getfilter(
      this.filtername,
      this.formattedStartDate,
      this.formattedEndDate,
      this.filtertype,
      this.filterstatus,
      this.filtermonth
    ).then((value) => {
      this.attendanceRequest = value.data
      this.showSpinner = false;
      this.updatePagedData();// Apply pagination after data fetch
    })
    this.aproveAll(this.approve);
  }

  aproveAll(approve: NgForm) {
    this.showSpinner = true;
    this.filtername;
    this.formattedStartDate;
    this.formattedEndDate;
    this.filtertype;
    this.filterstatus;
    this.filtermonth;

    const rea = approve.value.reason;
    const adminid = this.userInfo.id;
    this.addService.allApprove(adminid, rea,
      this.filtername,
      this.formattedStartDate,
      this.formattedEndDate,
      this.filtertype,
      this.filterstatus,
      this.filtermonth,
    ).then((value) => {
      this.showSpinner = false;
    })
  }

  formatDate(date: Date): string {
    if (date) {
      const year = date.getFullYear();
      const month = date.getMonth() + 1;
      const day = date.getDate();
      return `${year}/${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}`;
    } else {
      return '';
    }
  }


  sendAcceptedData(data: any) {

    this.id1 = data.id;
    this.attendence_id1 = data.attendance_id;
    this.check_in1 = data.check_in;
    this.check_out1 = data.check_out;
    this.overtime1 = data.overtime;
    this.working_hours = data.working_hours;
    this.status1 = 'approved';
    this.type1 = data.type;
  }
  sendRejectedData(data: any) {
    this.id1 = data.id;
    this.attendence_id1 = data.attendance_id;
    this.check_in1 = data.check_in;
    this.check_out1 = data.check_out;
    this.overtime1 = data.overtime;
    this.working_hours = data.working_hours
    this.status1 = 'rejected';
    this.type1 = data.type;
    this.getTextForAutomation();
  }

  aproveReq(attendance: NgForm) {
    this.showSpinner = true;
    this.id = this.id1;
    this.attendence_id = this.attendence_id1;
    this.check_in = this.check_in1;
    this.check_out = this.check_out1;
    this.working_hours = this.working_hours;
    this.overtime = this.overtime1;
    this.reason = attendance.value.reason;
    this.status = this.status1;
    this.type = this.type1;
    this.admin_id1 = this.userInfo.id;

    this.addService.getapprove(
      this.id,
      this.attendence_id,
      this.check_in,
      this.check_out,
      this.working_hours,
      this.overtime,
      this.status,
      this.type,
      this.admin_id1,
      this.reason
    ).then((value) => {
      this.showSpinner = false;
      if (value?.success) {
        this.closeModal('updateModal');
        this.reasonModal = '';
        this.getAtendancerequest();
      }
    });
  }

  rejectReq(attendance: NgForm) {
    this.showSpinner = true;
    this.id = this.id1;
    this.attendence_id = this.attendence_id1;
    this.check_in = this.check_in1;
    this.check_out = this.check_out1;
    this.working_hours = this.working_hours;
    this.overtime = this.overtime1;
    this.status = this.status1;
    this.type = this.type1;
    this.admin_id1 = this.userInfo.id;
    this.reason = this.reason1;

    this.addService.getapprove(
      this.id,
      this.attendence_id,
      this.check_in,
      this.check_out,
      this.working_hours,
      this.overtime,
      this.status,
      this.type,
      this.admin_id1,
      this.reason
    ).then((value) => {
      this.showSpinner = false;
      if (value?.success) {
        this.closeModal('rejectupdateModal');
        this.reason1 = '';
        this.getAtendancerequest();
      }
    });
  }

  private closeModal(modalId: string) {
    const jQuery = (window as any).jQuery;
    if (jQuery) {
      jQuery('#' + modalId).modal('hide');
      return;
    }

    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.remove('show');
      modal.setAttribute('aria-hidden', 'true');
      modal.style.display = 'none';
    }
    const backdrop = document.querySelector('.modal-backdrop');
    if (backdrop) {
      backdrop.remove();
    }
    document.body.classList.remove('modal-open');
  }

  trimText() {
    this.reason1 = this.reason1.replace(/\s+/g, ' ').trim();
  }
  user_detail() {
    this.showSpinner = true;
    this.dashboardService.getuserdetail().then((value) => {
      this.userInfo = value.data
      this.colormode = this.userInfo.color_mode
      this.sharedmode.setMode(this.colormode);
      this.showSpinner = false;
    })

  }
  isavailablefeature(type: string): boolean {
    switch (type) {
      case "isAccept":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.attendance_data.data.values.edit === false
      case "isReject":
        var user_role = JSON.parse(this.user.user_role.user_roles);
        return !user_role.attendance_data.data.values.delete === false
      default:
        return false;


    }
    return false
  }

}
